const twoFactorAuth =  {
    state: {
        recoveryCodes: [],
    },
    mutations: {
        setRecoveryCodes(state, recoveryCodes) {
            state.recoveryCodes = recoveryCodes;
        }
    },
    actions: {
        async generateRecoveryCodes({commit}) {
            const { data } = await axios.get('/api/user/recovery-code/generate');
            commit('setRecoveryCodes', data.data);
        }
    }
}

export default twoFactorAuth;